class Route {
    constructor(parameters) {
        this.name = parameters.name ?? null;
        this.path = parameters.path ?? null;
        this.component = parameters.component ?? null;
        this.children = parameters.children ?? null;
        this.beforeResolve = parameters.beforeResolve ?? null;
        this.beforeEnter = parameters.beforeEnter ?? null;

        this.meta = {
            roles: parameters.roles ?? [],
            permissions: parameters.permissions ?? [],
            label: parameters.label ?? null,
            hidden: parameters.hidden ?? false,
            breadcrumbs: parameters.breadcrumbs ?? false,
            translate: true, // translate label,
            priority: parameters.priority ?? 0
        };
    }
}

class RedirectRoute {
    constructor(parameters) {
        this.name = parameters.name ?? null;
        this.path = parameters.path ?? null;
        this.redirect = parameters.redirect;

        this.meta = {
            roles: parameters.roles ?? [],
            permissions: parameters.permissions ?? [],
            label: parameters.label ?? null,
            hidden: parameters.hidden ?? false,
            breadcrumbs: parameters.breadcrumbs ?? false,
            translate: true, // translate label,
            priority: parameters.priority ?? 0
        };
    }
}

export {
    Route,
    RedirectRoute
};
